import useStyles from 'isomorphic-style-loader/useStyles';
import React from 'react';
import PropTypes from 'prop-types';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import s from './LayoutMobile.css';
import menuIcon from './menu.svg';
import tapsiLogo from '../../../../assets/icons/tapsi-logo.svg';
import headerTabs from '../headerTabs';
import tapsiLogoWhite from '../../../../assets/icons/tapsi-logo-white.svg';
import footerTabs, { trustLogo } from '../footerTabs';
import socialLinks from '../socialLinks';
import RecaptchaStyle from '../recaptcha-no-modules.css';

export default function LayoutMobile({ children }) {
  useStyles(s, RecaptchaStyle);
  const [drawerOpen, setDrawerOpen] = React.useState(false);
  return (
    <div className={s.layout}>
      <header className={s.header}>
        <a href="https://tapsi.ir/">
          <img className={s.logo} alt="TAPSI" src={tapsiLogo} />
        </a>
        <button className={s.drawerButton} type="button" onClick={() => setDrawerOpen(true)}>
          <img alt="Menu" src={menuIcon} />
        </button>
      </header>
      <SwipeableDrawer anchor="top" open={drawerOpen} onOpen={() => setDrawerOpen(true)} onClose={() => setDrawerOpen(false)}>
        <div className={s.bottom}>
          {headerTabs.map(tab => (
            <a key={tab.link} className={`${s.tab} ${tab.active ? s.active : ''}`} href={tab.link}>
              {tab.title}
            </a>
          ))}
        </div>
      </SwipeableDrawer>

      <main className={s.main}>{children}</main>

      <footer className={s.footer}>
        <div className={s.brandCol}>
          <img className={s.footerLogo} src={tapsiLogoWhite} alt="TAPSI" />
          <h3>اپلیکیشن درخواست خودرو و پیک</h3>
        </div>
        {footerTabs.map(footerCol => (
          <div className={s.footerCol}>
            <h6>{footerCol.title}</h6>
            {footerCol.items.map(footerItem => (
              <a href={footerItem.link}>{footerItem.title}</a>
            ))}
          </div>
        ))}
        <div className={s.logoContainer}>
          {trustLogo.map(logo => (
            <div className={s.enamadLogo}>
              <picture className={s.enamadLogo}>
                <source srcSet={logo.imageWebp} type="image/webp" />
                <source srcSet={logo.imagePng} type="image/png" />
                <img src={logo.imagePng} alt={logo.name} loading="lazy" width="100%" />
              </picture>
            </div>
          ))}
        </div>
        <p className={s.footerDescription}>تمام حقوق مادی و معنوی این وبسایت متعلق به تپسی می باشد</p>
        <div className={s.socialLinks}>
          {socialLinks.map(social => (
            <a href={social.link}>
              <img src={social.icon} alt={social.alt} height="20px" />
            </a>
          ))}
        </div>
      </footer>
    </div>
  );
}

LayoutMobile.propTypes = {
  children: PropTypes.node.isRequired,
};
